import { buildLogin, loginUsecase as _loginUsecase } from "./login";
import { buildLogout, logoutUsecase as _logoutUsecase } from "./logout";
import { buildSendResetPasswordEmail, sendResetPasswordEmailUsecase as _sendResetPasswordEmailUsecase } from './sendResetPasswordEmail';
import { buildConfirmPasswordReset, confirmPasswordResetUsecase as _confirmPasswordResetUsecase } from './confirmPasswordReset';
import { buildReauthenticateUser, reauthenticateUserUsecase as _reauthenticateUserUsecase } from './reauthenticateUser';
import { buildVerifyAuth, verifyAuthUseCase as _verifyAuthUseCase } from "./verifyAuth";
import AuthServiceRepository from "../../ports/authServiceRepository";

// eslint-disable-next-line import/no-anonymous-default-export
export default (dependencies: {
  authServiceRepo: AuthServiceRepository;
}): {
  login: _loginUsecase;
  logout: _logoutUsecase;
  sendResetPasswordEmail: _sendResetPasswordEmailUsecase;
  confirmPasswordReset: _confirmPasswordResetUsecase;
  reauthenticateUser: _reauthenticateUserUsecase;
  verifyAuth: _verifyAuthUseCase;
} => {
  const { authServiceRepo } = dependencies;

  const login = buildLogin({ authServiceRepo });
  const logout = buildLogout({ authServiceRepo });
  const sendResetPasswordEmail = buildSendResetPasswordEmail({ authServiceRepo });
  const confirmPasswordReset = buildConfirmPasswordReset({ authServiceRepo });
  const reauthenticateUser = buildReauthenticateUser({ authServiceRepo });
  const verifyAuth = buildVerifyAuth({ authServiceRepo });

  return { login, logout, sendResetPasswordEmail, confirmPasswordReset, reauthenticateUser, verifyAuth };
};

export type loginUsecase = _loginUsecase;
export type logoutUsecase = _logoutUsecase;
export type sendResetPasswordEmailUsecase = _sendResetPasswordEmailUsecase;
export type confirmPasswordResetUsecase = _confirmPasswordResetUsecase;
export type reauthenticateUserUsecase = _reauthenticateUserUsecase;
export type verifyAuthUseCase = _verifyAuthUseCase;
